import classnames from 'classnames';
import React from 'react';
import { ClampText } from '../../../../../../components/clamp-text/clamp-text';
import styles from './description.scss';
const CardDescription = _ref => {
  let {
    text,
    withSeparator,
    isShrinkable,
    liveLabel
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.container, {
      [styles['with-separator']]: withSeparator,
      [styles['is-shrinkable']]: isShrinkable,
      [styles['with-live-label']]: Boolean(liveLabel)
    })
  }, liveLabel && /*#__PURE__*/React.createElement("span", {
    className: styles.live
  }, liveLabel), /*#__PURE__*/React.createElement(ClampText, {
    text: text,
    dataHook: "action-card-title"
  }));
};
export default CardDescription;
//# sourceMappingURL=description.js.map